// @flow
import { createSelector } from 'reselect';
import type { State, Plane } from '../types';
import { getActivityIndex } from '../utils/targetUtils';
import { sessionConfigSelector } from './configSelectors';

const planeStateSelector = (state: State) => state.planes;

export const planeListSelector = (state: State) => {
    const planeState = planeStateSelector(state);
    return planeState.list;
};

export const planeEntitiesSelector = (state: State) => {
    const planeState = planeStateSelector(state);
    return planeState.entities;
};

export const makePlaneEntitySelector = (icao: string) => (state: State) => {
    const entities = planeEntitiesSelector(state);
    return entities[icao] && entities[icao].system;
};

export const planeCountSelector = (state: State) => {
    const planeState = planeStateSelector(state);
    return planeState.list.length;
};

export const sortedPlaneListSelector = createSelector<$ReadOnlyArray<string>, $ReadOnlyArray<PlaneEntity>, SessionConfig, $ReadOnlyArray<string>>([
    planeListSelector,
    planeEntitiesSelector,
    sessionConfigSelector
], (planes, entities, sessionConfig) => {
    const entityMap = planes.map((icao => {
        const entity = entities[icao];
        const plane = entity && entity.system && entity.system[0];

        return {
            icao,
            activityIndex: getActivityIndex(plane && plane.TimeOfTrackInformation, sessionConfig)
        };
    }));

    entityMap.sort((a, b) => {
        if(a.activityIndex > b.activityIndex) {
            return -1;
        }
        else if(a.activityIndex < b.activityIndex) {
            return 1;
        }
        else {
            return 0;
        }
    });

    return entityMap.map(map => map.icao);
});

export const callsignSelector = (icao: string, planeBuffer?: $ReadOnlyArray<Plane>) => (state: State) => {
    const plane = planeBuffer && planeBuffer[0];
    return plane && plane.TargetIdentification;
};